import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../@fuse/components/sidebar/sidebar.service";
var SidenavService = /** @class */ (function () {
    function SidenavService(fuseSidebarService) {
        this.fuseSidebarService = fuseSidebarService;
    }
    SidenavService.prototype.open = function (sidenavName) {
        this.fuseSidebarService.getSidebar(sidenavName).open();
    };
    SidenavService.prototype.close = function (sidenavName) {
        this.fuseSidebarService.getSidebar(sidenavName).close();
    };
    SidenavService.prototype.toggle = function (sidenavName) {
        this.fuseSidebarService.getSidebar(sidenavName).toggleOpen();
    };
    SidenavService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SidenavService_Factory() { return new SidenavService(i0.ɵɵinject(i1.FuseSidebarService)); }, token: SidenavService, providedIn: "root" });
    return SidenavService;
}());
export { SidenavService };
